import React from 'react'
import { useAmISignedIn } from '@beatgig/auth-hooks'
import Link from '@beatgig/design/components/link'
import useArtistLikesPopupState from '@beatgig/ui/artist-likes-popup/use-artist-likes-state'
import useOpenArtistLikesPopup from '@beatgig/ui/artist-likes-popup/use-open-artist-likes-popup'

export default function SmartOpenLikesPopupLink(
  props: Omit<React.ComponentProps<typeof Link>, 'onPress' | 'children'>
) {
  const [isOpen] = useArtistLikesPopupState()
  const toggle = useOpenArtistLikesPopup()

  const { amISignedIn } = useAmISignedIn()

  if (!amISignedIn) return null

  return (
    <Link block {...props} onPress={() => toggle({ close: isOpen })}>
      Likes
    </Link>
  )
}
